// Carte d'affichage d'un message système
import React from 'react';
import {
  getMessageIcon,
  getMessageColor,
  getMessageBgClass,
  getMessageTypeLabel,
  getRelativeTime,
  extractTextFromHtml,
} from '../utils/messageHelpers';

/**
 * @param {{ message: Object, onClick: Function }} props
 */
const MessageCard = ({ message, onClick }) => {
  const color = getMessageColor(message.type);
  const excerpt = extractTextFromHtml(message.content, 100);

  return (
    <button
      onClick={() => onClick?.(message)}
      className={`
        w-full text-left rounded-xl border-2 p-4 transition-all duration-200
        hover:shadow-md hover:-translate-y-0.5
        bg-white dark:bg-gray-900
        ${message.isRead
          ? 'border-gray-200 dark:border-gray-700'
          : 'border-blue-300 dark:border-blue-700 shadow-sm shadow-blue-100 dark:shadow-blue-900/20'
        }
      `}
      style={!message.isRead ? { borderLeftColor: color, borderLeftWidth: '4px' } : {}}
      aria-label={`Message : ${message.title}`}
    >
      <div className="flex items-start justify-between gap-3">
        {/* Icône type */}
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-lg"
          style={{ backgroundColor: `${color}20` }}
        >
          {getMessageIcon(message.type)}
        </div>

        <div className="flex-1 min-w-0">
          {/* Ligne supérieure : type badge + indicateur non lu */}
          <div className="flex items-center gap-2 mb-1.5 flex-wrap">
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${getMessageBgClass(message.type)}`}>
              {getMessageTypeLabel(message.type)}
            </span>
            {message.priority === 'high' && (
              <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300">
                Prioritaire
              </span>
            )}
            {!message.isRead && (
              <span className="ml-auto flex items-center gap-1 text-xs font-semibold text-blue-600 dark:text-blue-400">
                <span className="w-2 h-2 bg-blue-500 rounded-full" />
                Non lu
              </span>
            )}
          </div>

          {/* Titre */}
          <h3 className={`font-semibold text-sm leading-tight mb-1 ${
            message.isRead
              ? 'text-gray-700 dark:text-gray-300'
              : 'text-gray-900 dark:text-gray-100'
          }`}>
            {message.title}
          </h3>

          {/* Extrait */}
          {excerpt && (
            <p className="text-xs text-gray-500 dark:text-gray-400 line-clamp-2 mb-2">
              {excerpt}
            </p>
          )}

          {/* Date */}
          <p className="text-xs text-gray-400 dark:text-gray-500">
            {getRelativeTime(message.publishedAt)}
          </p>
        </div>
      </div>

      {/* Bouton d'action si présent */}
      {message.actionButton?.label && (
        <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-800">
          <span
            className="text-xs font-medium px-3 py-1.5 rounded-lg text-white inline-block"
            style={{ backgroundColor: color }}
          >
            {message.actionButton.label} →
          </span>
        </div>
      )}
    </button>
  );
};

export default MessageCard;
